var $bf5cce1b47d23baf$exports = {};
$bf5cce1b47d23baf$exports = {
  "Clear search": "T\xF8m s\xF8k"
};
export { $bf5cce1b47d23baf$exports as default };